// extracted by mini-css-extract-plugin
module.exports = {"removeLinkStyle":"Summary_removeLinkStyle__12wcy"};